import React from 'react';
import { EducationDesignPreview } from '../education/EducationDesignExperiment';
import CoursePageClarityHome from './CoursePageClarityHome';

/**
 * Review route: /courses/ai-trading-bootcamp/clarity-home.
 * Mounts the Clarity Home bootcamp treatment inside a fixed control preview so
 * the shared education wrapper paints nothing extra. Never evaluates a flag or
 * records exposure; the PostHog experiment for this arm is loaded separately.
 */
export default function BootcampClarityHomeReview(): React.ReactElement {
  return (
    <div
      className="bootcamp-clarity-home-review education-design-experiment"
      data-bootcamp-design="clarity-home"
      data-experiment-active="false"
      data-testid="bootcamp-clarity-home-review"
    >
      <EducationDesignPreview variant="control">
        <CoursePageClarityHome />
      </EducationDesignPreview>
    </div>
  );
}
